// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/IssuesReports/IssuesList/imgstyle.css
// module id = 796
// module chunks = 0